/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Monthly_TitleInputs */

const es_billing_monthly_title = /** @type {(inputs: Billing_Monthly_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación mensual`)
};

const en_billing_monthly_title = /** @type {(inputs: Billing_Monthly_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly billing`)
};

/**
* | output |
* | --- |
* | "Monthly billing" |
*
* @param {Billing_Monthly_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_monthly_title = /** @type {((inputs?: Billing_Monthly_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Monthly_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_monthly_title(inputs)
	return en_billing_monthly_title(inputs)
});
export { billing_monthly_title as "billing.monthly.title" }